module Meevo.Components.Search {
  angular.module("meevo.components.search", []);
}